import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllLineTypes } from "../api/getAllLineTypes";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useLineTypesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetLineType []>([]);
  const getAllLineTypesQuery = useGetAllLineTypes({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllLineTypesQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllLineTypesQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllLineTypesQuery.data ? getAllLineTypesQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Είδος Γραμμής",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Είδους Γραμμής");
        break;
      case "edit":
        title = t("Επεξεργασία Είδους Γραμμής");
        break
        case "delete":
        title = t("Διαγραφή Είδους Γραμμής");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=> {
    setSelectedRowsOfTable([]);
    getAllLineTypesQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
